/**
 * The renderer's and the shell's words for a list's presentations (the view switch, list-views.ts),
 * a list laid on its days (list standard §13, calendar.tsx) and the member's own calendar
 * (`calendar.mine`, the shell's MyCalendar). Kept beside the catalogue and spread into it, so a
 * parallel change to the catalogue does not collide with these.
 */
export const CALENDAR_EN = {
    'list.view.label': 'Show as',
    'list.view.table': 'Table',
    'list.view.board': 'Board',
    'list.view.calendar': 'Calendar',
    'list.view.timeline': 'Timeline',
    'calendar.period.previous': 'Previous month',
    'calendar.period.next': 'Next month',
    'calendar.period.today': 'Today',
    'calendar.week.previous': 'Previous week',
    'calendar.week.next': 'Next week',
    'calendar.view.label': 'Calendar view',
    'calendar.view.month': 'Month',
    'calendar.view.week': 'Week',
    'calendar.view.agenda': 'Agenda',
    'calendar.today': 'Today',
    'calendar.more': '+{n} more',
    'calendar.day.rows': '{n} on this day',
    'calendar.nothing': 'Nothing on these days',
    'calendar.nothing.day': 'Nothing on this day',
    'calendar.undated': '{n} rows have no date, so they are on no day; the table shows them.',
    'calendar.scope.partial': 'Showing {shown} of {total} on these days — narrow the filters to see the rest.',
    'nav.calendar.mine': 'My calendar',
    'calendar.mine.title': 'My calendar',
    'calendar.mine.lede': 'Your leave, tasks, meetings and milestones from every unit, read live with your own access.',
    'calendar.mine.show': 'Show',
    'calendar.mine.unavailable': '{feed} is not available right now; the rest are shown.',
    'calendar.mine.none': 'Nothing you may see is offered to your calendar yet.',
    'calendar.mine.column.title': 'Item',
    'calendar.mine.column.day': 'Day',
    'calendar.mine.column.until': 'Until',
    'calendar.mine.column.feed': 'From',
    'calendar.mine.column.status': 'Status',
};
export const CALENDAR_AR = {
    'list.view.label': 'اعرض كـ',
    'list.view.table': 'جدول',
    'list.view.board': 'لوحة',
    'list.view.calendar': 'تقويم',
    'list.view.timeline': 'مخطط زمني',
    'calendar.period.previous': 'الشهر السابق',
    'calendar.period.next': 'الشهر التالي',
    'calendar.period.today': 'اليوم',
    'calendar.week.previous': 'الأسبوع السابق',
    'calendar.week.next': 'الأسبوع التالي',
    'calendar.view.label': 'عرض التقويم',
    'calendar.view.month': 'شهر',
    'calendar.view.week': 'أسبوع',
    'calendar.view.agenda': 'أجندة',
    'calendar.today': 'اليوم',
    'calendar.more': '+{n} أخرى',
    'calendar.day.rows': '{n} في هذا اليوم',
    'calendar.nothing': 'لا شيء في هذه الأيام',
    'calendar.nothing.day': 'لا شيء في هذا اليوم',
    'calendar.undated': '{n} من الصفوف بلا تاريخ فلا تقع على يوم؛ يعرضها الجدول.',
    'calendar.scope.partial': 'يُعرض {shown} من {total} في هذه الأيام — ضيّق المرشحات لترى البقية.',
    'nav.calendar.mine': 'تقويمي',
    'calendar.mine.title': 'تقويمي',
    'calendar.mine.lede': 'إجازاتك ومهامك واجتماعاتك ومعالم مشاريعك من كل الوحدات، تُقرأ مباشرة بصلاحياتك أنت.',
    'calendar.mine.show': 'اعرض',
    'calendar.mine.unavailable': '{feed} غير متاحة الآن؛ يُعرض الباقي.',
    'calendar.mine.none': 'لا يُعرض على تقويمك بعدُ شيء يحق لك رؤيته.',
    'calendar.mine.column.title': 'البند',
    'calendar.mine.column.day': 'اليوم',
    'calendar.mine.column.until': 'حتى',
    'calendar.mine.column.feed': 'من',
    'calendar.mine.column.status': 'الحالة',
};
//# sourceMappingURL=i18n-calendar.js.map